import React, { FC } from "react";
import styled, { keyframes } from 'styled-components';
import { CurrentUser } from '../../../providers/currentUser';
import { DivPrimaryOrangeButton, ASecondaryOrangeButton, DivSecondaryOrangeButtonDisable } from '../../../components/utility/buttons';
import { createCalcAnswerSet } from '../../../actions/actions';
import { DivFlexCenCen } from "../../../components/utility/flex";
import { PTextSecondaryCenXS } from "../../../components/utility/textSecondary";
import { DivWrap } from "../../../components/utility/wrap";
import { ALink } from "../../../components/utility/link";

type Props = {
  questionSetId: number;
  currentUser: CurrentUser;
}

export const CalcChallengeButton:FC<Props> = (props: Props) => {
  const { questionSetId, currentUser } = props;

  if(currentUser.isActivated) {
    return(
      <div>
        <DivWrap>
          <DivButtonWrap>
            <DivPrimaryOrangeButton onClick={() => createCalcAnswerSet(questionSetId)}>チャレンジする</DivPrimaryOrangeButton>
          </DivButtonWrap>
        </DivWrap>
      </div>
    )
  } else {
    return(
      <>
        <DivButtonWrap>
          <DivSecondaryOrangeButtonDisable>チャレンジする</DivSecondaryOrangeButtonDisable>
          <DivFlexCenCen>
            <PTextSecondaryCenXS>
              計算道場は、会員登録するとチャレンジできます。
            </PTextSecondaryCenXS>
          </DivFlexCenCen>
        </DivButtonWrap>
      </>
    )
  }
}

const DivButtonWrap = styled.div`
  width: 12rem;
`;
